

import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import showicon from "../assets/showicon.svg";
import hide from "../assets/hide.svg";

const CustomPasswordInput = ({
  placeholder,
  value,
  onChange,
  onBlur,
  name = 'password',
  width,
  height = '42px',
  fontSize = '14px',
  borderColor = '#091E4224',
  focusBorderColor = '#006EC2',
  placeholderColor = '#A0A0A0',
  borderRadius = '6px',
  initiallyVisible = false,
  error = false,
  helperText = "",
  ...rest
}) => {
  const [show, setShow] = useState(initiallyVisible);

  const toggleVisibility = () => setShow((prev) => !prev);

  return (
    <Box sx={{ width: width || '100%' }}>
      <Box
        sx={{
          height,
          display: 'flex',
          alignItems: 'center',
                  border:error
      ? "1px solid red"
      : "2px solid  #091E4224",
          // border: `2px solid ${error ? '#d32f2f' : borderColor}`,
          borderRadius,
          px: 1.5,
          '&:focus-within': {
            // border: `2px solid ${error ? '#d32f2f' : focusBorderColor}`,
                border:error
      ? "1px solid red"
      :"2px solid  #006EC2",
          },
        }}
      >
        <Box
          component="input"
          type={show ? 'text' : 'password'}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder || ''}
          sx={{
            border: 'none',
            outline: 'none',
            fontSize,
            width: '100%',
            height: '100%',
            fontFamily: 'Poppins, sans-serif',
            color: '#333',
            '::placeholder': { color: placeholderColor },
          }}
          {...rest}
        />

        <Box
          component="img"
          src={show ? showicon : hide}
          alt={show ? 'Hide password' : 'Show password'}
          sx={{
            width: 20,
            height: 20,
            ml: 1,
            cursor: 'pointer',
            objectFit: 'contain',
          }}
          onClick={toggleVisibility}
        />
      </Box>
      {error && (
        <Typography sx={{ fontSize: 12, color: '#d32f2f', mt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomPasswordInput;
